// import React from 'react';
import moment from 'moment';

const DateFormat = ({ date, format="MMM D, YYYY" }) => moment(date).utc().format(format)

export default DateFormat;
